import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
import { serverDetailList, editServerState, editServerRealOpenTime, syncCpConfig } from "@/api/data";
export default {
  data: function data() {
    return {
      //当前准备修改的服务器状态label
      sel_server: "",
      //更改后的服务器状态
      newSel_ser: "",
      //服务器ID
      server_id: "",
      //服务器名称
      server_name: "",
      real_open_time_str: "",
      centerDialogVisible: false,
      realOpenDialogVisible: false,
      //弹窗开服时间
      value1: "",
      //当前准备修改的服务器状态
      stateCodeMsg: 0,
      tableData: [],
      //把当前时间之前的日期都设置无法选中
      option: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        }
      },
      serverOptions: [{
        label: "未准备",
        //研发还没备好，但是在服务器列表里的服（能修改开服时间）
        value: -2 //还没开的服，最早只能修改到当前时间的5分钟之后开服，不能修改到当前时间之前的之后
      }, {
        label: "未开服",
        //研发已经备好，但是没到开服时间的服（可以调用研发接口修改开服时间）
        value: -1 //还没开的服，最早只能修改到当前时间的5分钟之后开服，不能修改到当前时间之前的之后
      }, {
        label: "新服",
        //不能调用研发接口修改开服时间，能更新状态
        value: 0
      }, {
        label: "流畅",
        //不能调用研发接口修改开服时间，能更新状态
        value: 1
      }, {
        label: "火爆",
        //不能调用研发接口修改开服时间，能更新状态
        value: 2
      }, {
        label: "爆满",
        //不能调用研发接口修改开服时间，能更新状态
        value: 3
      }, {
        label: "维护",
        //不能调用研发接口修改开服时间，能更新状态
        value: 4
      }],
      options: []
    };
  },
  watch: {
    sel_server: function sel_server(newVal) {
      this.newSel_ser = newVal;
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return serverDetailList();
            case 2:
              res = _context.sent;
              if (!res.data || res.data.length == 0) {
                _this.$message({
                  message: "暂无数据"
                });
              } else {
                _this.tableData = res.data;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    modifyMsg: function modifyMsg(row) {
      for (var i = 0; i < this.serverOptions.length; i++) {
        if (row.stateCode == this.serverOptions[i].value) {
          this.sel_server = this.serverOptions[i].label;
        }
      }
      this.server_id = row.serverId;
      this.server_name = row.serverName;
      this.value1 = row.openTimeStr;
      this.stateCodeMsg = row.stateCode;

      // 弹出框的服务器状态下拉框
      var statusList = row.stateCode < 0 ? [-2, -1, 0, 2] : [0, 2];
      this.options = JSON.parse(JSON.stringify(this.serverOptions)).filter(function (item) {
        return statusList.indexOf(item.value) > -1;
      });
      this.centerDialogVisible = true;
    },
    realOpentimeModifyMsg: function realOpentimeModifyMsg(row) {
      for (var i = 0; i < this.serverOptions.length; i++) {
        if (row.stateCode == this.serverOptions[i].value) {
          this.sel_server = this.serverOptions[i].label;
        }
      }
      this.server_id = row.serverId;
      this.server_name = row.serverName;
      this.value1 = row.openTimeStr;
      this.stateCodeMsg = row.stateCode;
      if (row.realOpenTimeStr == '1970-01-01 00:00:00') {
        this.real_open_time_str = row.openTimeStr;
      } else {
        this.real_open_time_str = row.realOpenTimeStr;
      }
      // 弹出框的服务器状态下拉框
      var statusList = row.stateCode < 0 ? [-2, -1, 0, 2] : [0, 2];
      this.options = JSON.parse(JSON.stringify(this.serverOptions)).filter(function (item) {
        return statusList.indexOf(item.value) > -1;
      });
      this.realOpenDialogVisible = true;
    },
    modifyData: function modifyData(time) {
      //修改的这个时间,最早必须是当前时间的五分钟后
      //如果选择比当前时间小的，就默认在当前时间基础上加5分钟
      var startAt = new Date(time) * 1000 / 1000;
      var curTime = new Date();
      var addMinute = new Date(curTime.setMinutes(curTime.getMinutes() + 5));
      if (startAt < Date.now()) {
        this.value1 = addMinute;
      }
    },
    preserBtn: function preserBtn() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return editServerState({
                state_code: _this2.newSel_ser,
                server_id: _this2.server_id
              });
            case 2:
              res = _context2.sent;
              if (res.code == 0) {
                _this2.$message({
                  type: "success",
                  message: "恭喜你，修改服务器状态成功"
                });
                _this2.init(); //刷新页面
                _this2.centerDialogVisible = false;
              } else {
                _this2.$message({
                  type: "error",
                  message: "出错啦，快找人"
                });
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    saveRealOpenTimeBtn: function saveRealOpenTimeBtn() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return editServerRealOpenTime({
                server_id: _this3.server_id,
                real_open_time_str: _this3.real_open_time_str
              });
            case 2:
              res = _context3.sent;
              if (res.code == 0) {
                _this3.$message({
                  type: "success",
                  message: "修改成功"
                });
                _this3.init(); //刷新页面
                _this3.centerDialogVisible = false;
              } else {
                _this3.$message({
                  type: "error",
                  message: "出错啦，快找人"
                });
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    openConfig: function openConfig() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return syncCpConfig({
                type: "c_server"
              });
            case 2:
              res = _context4.sent;
              if (res.code === 0) {
                _this4.$message({
                  message: "同步cp配置成功",
                  type: "success"
                });
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    openBox: function openBox() {
      this.$notify({
        title: "服务器列表",
        dangerouslyUseHTMLString: true,
        message: "<div>（1）研发需要提供接口：获取游戏服务器列表接口，修改服务器开服时间和状态接口</div>" + "<div>（2）服务器列表包含：服务器Id，服务器名称，服务器状态，是否合服，合服后的主服务器Id，合服后的服务器名称</div>" + "<div>（3）服务器状态包含：（最新，热门，爆满，未开服，未准备）" + "<div>（4）根据研发提供的服务器列表接口，显示游戏的服务器列表，按开服时间排序，新开服在前面" + "<div>--------1：已经开的服（不能调用研发接口修改开服时间，能更新状态</div>" + "<div>--------2：研发已经备好，但是没到开服时间的服（可以调用研发接口修改开服时间）</div>" + "<div>--------3：研发还没备好，但是在服务器列表里的服（能修改开服时间）</div>" + "<div>--------还没开的服，最早只能修改到当前时间的5分钟之后开服，不能修改到当前时间之前的之后</div>",
        duration: 0
      });
    },
    getStateDesc: function getStateDesc(stateCode) {
      var _iterator = _createForOfIteratorHelper(this.serverOptions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.value == stateCode) {
            return item.label;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return '';
    }
  }
};